import { create } from "zustand";
import type { ProjectImportDestinationKind } from "./projectImportStore";

type AddProjectSourceRequestMode = "cmmd-project";

interface CommandPaletteStore {
  open: boolean;
  addProjectSourcesRequested: boolean;
  /** null = show all sources with forge-cloud default (generic open) */
  addProjectSourcesInitialDestination: ProjectImportDestinationKind | null;
  /** null = show source picker; otherwise jump directly into a specific import source */
  addProjectSourcesInitialMode: AddProjectSourceRequestMode | null;
  setOpen: (open: boolean) => void;
  toggleOpen: () => void;
  /** Generic open — shows all sources, forge-cloud default */
  openAddProjectSources: () => void;
  /** Opens palette directly into one import source */
  openAddProjectSourceMode: (mode: AddProjectSourceRequestMode) => void;
  /** Opens palette pre-filtered to cloud-only sources */
  openAddCloudProjectSources: () => void;
  /** Opens palette pre-filtered to local-only sources, desktop-local default */
  openAddLocalProjectSources: () => void;
  consumeAddProjectSourcesRequest: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteStore>((set) => ({
  open: false,
  addProjectSourcesRequested: false,
  addProjectSourcesInitialDestination: null,
  addProjectSourcesInitialMode: null,
  setOpen: (open) => set({ open }),
  toggleOpen: () => set((state) => ({ open: !state.open })),
  openAddProjectSources: () =>
    set({
      open: true,
      addProjectSourcesRequested: true,
      addProjectSourcesInitialDestination: null,
      addProjectSourcesInitialMode: null,
    }),
  openAddProjectSourceMode: (mode) =>
    set({
      open: true,
      addProjectSourcesRequested: true,
      addProjectSourcesInitialDestination: null,
      addProjectSourcesInitialMode: mode,
    }),
  openAddCloudProjectSources: () =>
    set({
      open: true,
      addProjectSourcesRequested: true,
      addProjectSourcesInitialDestination: "forge-cloud",
      addProjectSourcesInitialMode: null,
    }),
  openAddLocalProjectSources: () =>
    set({
      open: true,
      addProjectSourcesRequested: true,
      addProjectSourcesInitialDestination: "desktop-local",
      addProjectSourcesInitialMode: null,
    }),
  consumeAddProjectSourcesRequest: () =>
    set({
      addProjectSourcesRequested: false,
      addProjectSourcesInitialDestination: null,
      addProjectSourcesInitialMode: null,
    }),
}));
